import { createContext, ReactNode, useContext, useEffect } from 'react';

import { initialize, reactPlugin } from './AppInsightsService';

const AppInsightsContext = createContext(reactPlugin);

const AppInsightsProvider = ({
  connectionString,
  children
}: {
  connectionString?: string;
  children: ReactNode;
}) => {
  useEffect(() => {
    if (connectionString) {
      initialize(connectionString);
    } else {
      throw new Error('Instrumentation key not provided');
    }
  }, [connectionString]);

  return (
    <AppInsightsContext.Provider value={reactPlugin}>
      {children}
    </AppInsightsContext.Provider>
  );
};

const useAppInsightsContext = () => useContext(AppInsightsContext);

export { AppInsightsContext, AppInsightsProvider, useAppInsightsContext };
